/**
 * imageUtils.js - 이미지 처리 관련 유틸리티
 */

/**
 * 아이템 객체에서 사용 가능한 모든 이미지 정보를 추출하여 표준화된 배열로 반환
 * (ImageModal에서 사용하기 위함)
 * 
 * @param {Object} item - 제품/재고 정보 객체
 * @returns {Array} [{url, title, alt}, ...] 표준화된 이미지 배열
 */
export const extractImages = (item) => {
    if (!item) return [];

    const images = [];
    const addedUrls = new Set(); // 중복 URL 방지
    const itemNm = item.itemNm || '';

    // URL 표준화 처리 함수
    const normalizeUrl = (url) => {
        if (!url) return null;
        let fullUrl = url;
        // 상대 경로이고 http로 시작하지 않는 경우 API URL 붙이기 (필요 시)
        // 현재 프로젝트 컨텍스트에 따라 조정: 이미지가 '/'로 시작하면 API_URL이 필요할 수 있음
        if (fullUrl.startsWith('/') && process.env.REACT_APP_API_URL) {
            fullUrl = `${process.env.REACT_APP_API_URL}${fullUrl}`;
        } else if (!fullUrl.startsWith('http') && !fullUrl.startsWith('/') && process.env.REACT_APP_API_URL) {
            // 'uploads/...' 같은 경로 처리
            fullUrl = `${process.env.REACT_APP_API_URL}/${fullUrl}`;
        }
        return fullUrl;
    };

    const addImage = (url, title, alt) => {
        const fullUrl = normalizeUrl(url);
        if (fullUrl && !addedUrls.has(fullUrl)) {
            images.push({ url: fullUrl, title, alt });
            addedUrls.add(fullUrl);
        }
    };

    // 1. 썸네일 (thFilePath)
    if (item.thFilePath && item.thFilePath !== 'null') {
        addImage(item.thFilePath, itemNm, `${itemNm} 썸네일`);
    }

    // 2. 메인 이미지 (FilePath / FILEPATH - 대소문자 모두 대응)
    const mainFilePath = item.FilePath || item.FILEPATH;
    if (mainFilePath && mainFilePath !== 'null') {
        addImage(mainFilePath, itemNm, `${itemNm} 대표 이미지`);
    }

    // 3. fileData / subData 등의 배열 내 이미지
    if (item.fileData && Array.isArray(item.fileData)) {
        item.fileData.forEach((file, index) => {
            if (file.filePath) {
                addImage(
                    file.filePath,
                    file.realNm || `상세 이미지 ${index + 1}`,
                    `${itemNm} 상세 ${index + 1}`
                );
            }
        });
    }

    return images;
};
